import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ruTranslations from "./locales/ru.json";
import kzTranslations from "./locales/kz.json";
import enTranslations from "./locales/en.json";

export type LanguageCode = "en" | "ru" | "kz";

// Определяем доступные языки
export const languages = {
  en: { code: "en" as const, name: "English", flag: "🇺🇸" },
  kz: { code: "kz" as const, name: "Қазақша", flag: "🇰🇿" },
  ru: { code: "ru" as const, name: "Русский", flag: "🇷🇺" },
};

// Инициализация i18n
i18n.use(initReactI18next).init({
  resources: {
    ru: {
      translation: ruTranslations,
    },
    kz: {
      translation: kzTranslations,
    },
    en: {
      translation: enTranslations,
    },
  },
  lng: "kz", // язык по умолчанию
  fallbackLng: "kz",
  interpolation: {
    escapeValue: false, // не нужно для React
  },
});

export default i18n;
